import { useState } from "react";
import { useOasisBackend } from '../hooks/useOasisBackend'
import { Input } from './ui/input';
import Modal from 'react-modal';

const SendPasswordResetButton = () => {
    const [email, setEmail] = useState("")
    const [isOpen, setIsOpen] = useState(false);
    const db = useOasisBackend();

    const sendEmail = async () => {
        await db.endpoints.passwordResetEmail.passwordResetEmailCreate({email: email})
        alert("You have been emailed if you have an account")
    }

      
      return(<>
      <div className="text-glow text-xs cursor-pointer" onClick={() => setIsOpen(true)}>Reset Password</div>
      <Modal
        isOpen={isOpen} 
        onRequestClose={() => (setIsOpen(false))}
        style={{
          overlay: {
            zIndex: 100,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '1rem'
          }, 
          content: {
            padding: 0, 
            zIndex: 1000, 
            background: "transparent", 
            border: 'none',
            position: 'relative',
            top: 'auto',
            left: 'auto',
            right: 'auto',
            bottom: 'auto',
            width: '100%',
            maxWidth: '500px',
            margin: '0 auto'
          }
        }}
      >
        <div className="flex flex-col bg-white justify-top bg-secondary w-full max-w-md mx-auto p-4 md:p-6 drop-shadow-2xl text-center rounded-lg">
            <h1 className="text-glow glow-shadow text-lg md:text-2xl lg:text-4xl pb-2 md:pb-4">Reset Password</h1>
            <p className="flex pt-4 md:pt-6 flex-col text-text gap-4 md:gap-8 text-sm md:text-lg lg:text-2xl self-center justify-center w-full">
                <Input 
                  type="email" 
                  placeholder="Email" 
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full text-sm md:text-base"
                />
            </p>
            <div className="flex flex-col sm:flex-row self-center gap-2 md:gap-4 pt-4 md:pt-6 w-full">
                <button
                    className="mt-2 md:mt-4 bg-gradient-to-br px-3 md:px-4 relative group/btn from-black to-neutral-600 block w-full sm:w-auto text-white rounded-md h-10 font-medium shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset] text-sm md:text-base"
                    type="submit"
                    onClick={() => (setIsOpen(false))}
                >
                    Cancel
                </button>    
                <button
                    className="mt-2 md:mt-4 bg-gradient-to-br text-nowrap w-full sm:w-auto px-3 md:px-4 relative group/btn from-black to-neutral-600 block text-white rounded-md h-10 font-medium shadow-[0px_1px_0px_0px_#ffffff40_inset,0px_-1px_0px_0px_#ffffff40_inset] text-sm md:text-base"
                    type="submit"
                    onClick={sendEmail}
                >
                    Send Reset Email
                </button>
            </div>
        </div>
    </Modal></>)
}

export default SendPasswordResetButton;